
<template>
<div id="app">
    <div class="app-content">
        <router-view
            :baseUrl="baseUrl"
            :stripeKey="StripeKey"
            :googleMapsApiKey="googleMapsApiKey"
            @add-to-cart="addItemToCart"
            @showChatWindow="showChatWindow"
            >
        </router-view>
        <ShoppingCart />
    </div>
    <footer-section v-if="reportPage" />
    <HealthInfoConsentModal />
</div>
</template>

<script>
import FooterElement from './components/common/footerElement.vue'
import ShoppingCart from './components/product/shoppingCart.vue'
import HealthInfoConsentModal from './components/common/HealthInfoConsentModal.vue'
import { initializeProducts } from '@/utils/productData'
//import blurryLoader from './components/common/blurryLoader.vue'

const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
const StripeKey = process.env.VUE_APP_STRIPE_KEY;
const GoogleMapsApiKey = process.env.VUE_APP_GOOGLE_KEY;

const CACHE_KEY = 'cached_products';
//const CACHE_DURATION = 24 * 60 * 60 * 1000;

export default {
    name: 'App',
    components: {
        'footer-section': FooterElement,
        ShoppingCart,
        HealthInfoConsentModal
        //blurryLoader
    },
    data() {
        return {
            baseUrl: `${apiEndpoint}`,
            StripeKey: StripeKey,
            googleMapsApiKey: GoogleMapsApiKey,
            isLoading: true,
            products: [{
                    "id": "675ac4cb6bf102c19ec3afe9",
                    "name": "Tirzepatide",
                    "sku": "23_1",
                    "type": "Injection",
                    "variant": null,
                    "url": "tirzepatide",
                    "brand_name": "Compound Medication",
                    "image_pre_text": "tirzepatide",
                    "pharmacy": "OpenLoop",
                    "form_name": "WeightLoss",
                    "category": {
                        "primary": "Weight",
                        "secondary": null,
                        "tertiary": null
                    },
                    "marketing": {},
                    "product_bullets": [],
                    "dropdowns": [],
                    "benefits": {},
                    "testimonials": [],
                    "pricing": {
                        "retail_price": 349.97,
                        "unit": "whole",
                        "discount_percentage": 33,
                        "shipping_cost": 0,
                        "shipping_type": "Ground",
                        "additional_cost": 0
                    },
                    "is_subscription": 1,
                    "is_addon": false,
                    "stripe_id": "tirz_plan_1",
                    "is_prescription": 1
                },
                {
                    "id": "675ac4cb6bf102c19ec3afec",
                    "name": "Semaglutide",
                    "sku": "24",
                    "type": "Injection",
                    "variant": null,
                    "url": "semaglutide",
                    "brand_name": "Compound Medication",
                    "image_pre_text": "semaglutide",
                    "pharmacy": "OpenLoop",
                    "form_name": "WeightLoss",
                    "category": {
                        "primary": "Weight",
                        "secondary": null,
                        "tertiary": null
                    },
                    "marketing": {},
                    "product_bullets": [],
                    "dropdowns": [],
                    "benefits": {},
                    "testimonials": [],
                    "pricing": {
                        "retail_price": 199.97,
                        "unit": "whole",
                        "discount_percentage": 33,
                        "shipping_cost": 0,
                        "shipping_type": "Ground",
                        "additional_cost": 0
                    },
                    "is_subscription": 1,
                    "is_addon": false,
                    "stripe_id": "sema_plan_278928",
                    "is_prescription": 1
                },
                {
                    "id": "684b25127fc4b1cb8576f02d",
                    "name": "GLP Anti-Nausea",
                    "sku": "25",
                    "type": "Injection",
                    "variant": null,
                    "url": "glp-anti",
                    "brand_name": "Compound Medication",
                    "image_pre_text": "glp-nausia",
                    "pharmacy": "OpenLoop",
                    "form_name": "WeightLoss",
                    "category": {
                        "primary": "Weight",
                        "secondary": null,
                        "tertiary": null
                    },
                    "marketing": {},
                    "product_bullets": [],
                    "dropdowns": [],
                    "benefits": {},
                    "testimonials": [],
                    "pricing": {
                        "retail_price": 19.97,
                        "unit": "whole",
                        "discount_percentage": 0,
                        "shipping_cost": 0,
                        "shipping_type": "Ground",
                        "additional_cost": 0
                    },
                    "is_subscription": 1,
                    "is_addon": true,
                    "stripe_id": "glp_nausia",
                    "is_prescription": 1
                }
            ]
        }
    },
    created() {
        this.initializeApp();
        this.$store.dispatch('captureTrackingData');

        setTimeout(() => {
            this.$store.dispatch('initTheme');
        }, 500);
    },
    computed: {
        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },
        isNotFormPage(){
            let rname = this.$route.name;
            return !['FormLoader','WeightLossFlowTwoHome','reportPage','choosePlan','leadDisqualified','ResetPassword','LoginPage','ForgotPassword'].includes(rname);
        },
        reportPage() {
            let rname = this.$route.name;
            return !['CareCalendar', 'Calendar','embeddablesForm','reportPage','checkoutCallCenter','checkoutWeightLoss','HomePage','DashboardOrders','DashboardMessages','DashboardProfile','DashboardBilling','DashboardReferrals','DashboardMedicalForm','DashboardUpgrade','DashboardChangeTreatment','DashboardCheckin','DashboardVerifyAddress'].includes(rname);
        },
        isDashboardPage() {
            let rname = this.$route.name;
            return ['HomePage','DashboardOrders','DashboardMessages','DashboardProfile','DashboardBilling','DashboardReferrals','DashboardMedicalForm','DashboardUpgrade','DashboardChangeTreatment','DashboardCheckin','DashboardVerifyAddress'].includes(rname);
        }
    },
    methods: {
        showChatWindow(){
            this.$root.$emit('toggle-chat');
        },
        addItemToCart(item) {
            this.$store.dispatch('addToCart', item);
        },
        async initializeApp() {
            try {
                await this.loadProducts();
            } catch (error) {
                console.error('Failed to initialize app:', error);
            }
        },
        async loadProducts() {
            try {
                const products = this.products;
                
                localStorage.setItem(CACHE_KEY, JSON.stringify({
                    timestamp: Date.now(),
                    products
                }));
                
                initializeProducts(products);
                return products;
            } catch (error) {
                console.error('Error fetching/caching products:', error);
                
                const cachedData = localStorage.getItem(CACHE_KEY);
                if (cachedData) {
                    const { products } = JSON.parse(cachedData);
                    initializeProducts(products);
                    this.isLoading = false;
                    return products;
                }
                
                this.isLoading = false;
                throw error;
            }
        }
    }
}
</script>

<style>
/* App layout - unscoped to reach child components */
#app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.app-content {
    flex: 1 0 auto;
}

.footer {
    flex-shrink: 0;
}

/* Mobile: push footer below initial viewport */
@media screen and (max-width: 767px) {
    .app-content {
        min-height: 100vh;
    }
}
</style>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    z-index: 9999;
}
</style>